module.exports = __webpack_public_path__ + "static/newsletter-1e0e9ffe829c0ac94d867f823a9b8672.jpg";